import React from "react";
import {inject, observer} from "mobx-react";
import {Alert, Button, Modal, ModalBody, ModalFooter, ModalHeader, Spinner} from "reactstrap";
import {formatEuros, messageResultat, STATUTS_FINAUX} from "../../../util/terminal";

const COULEURS = {completed: "success", cancelled: "secondary", failed: "danger", mismatch: "warning"};

/**
 * Fenêtre d'attente du paiement carte envoyé au lecteur Zettle : suit terminalStore.paiement jusqu'au résultat.
 * onTermine(paiement) est appelé une fois le résultat connu (actualiser la facture).
 */
const PaiementCarteModal = inject("rootStore")(observer(class PaiementCarteModal extends React.Component {

    get store() {
        return this.props.rootStore.terminalStore;
    }

    componentDidUpdate() {
        const paiement = this.store.paiement;
        if (paiement && STATUTS_FINAUX.includes(paiement.statut) && this.signale !== paiement.id) {
            this.signale = paiement.id;
            this.props.onTermine && this.props.onTermine(paiement);
        }
    }

    /** Une fois le paiement lancé sur le lecteur, le site ne peut pas l'arrêter : on prévient avant d'annuler. */
    annuler(paiement) {
        if (paiement.statut === "taken" && !window.confirm("Le paiement est peut-être en cours sur le lecteur. "
            + "Annulez-le aussi sur le lecteur ou le téléphone. Si la carte est débitée quand même, le paiement sera signalé "
            + "« à vérifier » sans être enregistré sur la facture.\n\nAnnuler quand même ?")) {
            return;
        }
        this.store.annuler();
    }

    componentWillUnmount() {
        this.store.oublier();
    }

    render() {
        const paiement = this.store.paiement;
        if (!paiement) {
            return null;
        }
        const fini = STATUTS_FINAUX.includes(paiement.statut);

        return (
            <Modal isOpen={true} centered backdrop="static" keyboard={false}>
                <ModalHeader>
                    <i className="fa fa-credit-card mr-2" aria-hidden="true"/>
                    Paiement carte de {formatEuros(paiement.montant_centimes)}
                </ModalHeader>
                <ModalBody className="text-center">
                    {fini ? (
                        <Alert color={COULEURS[paiement.statut]} className="mb-0">{messageResultat(paiement)}</Alert>
                    ) : (
                        <>
                            <Spinner color="primary" className="mb-3"/>
                            <p className="mb-0">{messageResultat(paiement)}</p>
                        </>
                    )}
                </ModalBody>
                <ModalFooter>
                    {!fini && paiement.statut === "taken" && (
                        <small className="text-muted mr-auto">Annuler libère l'écran ; annulez aussi sur le lecteur ou le téléphone.</small>
                    )}
                    {!fini && (
                        <Button color="danger" onClick={() => this.annuler(paiement)}>
                            Annuler
                        </Button>
                    )}
                    {fini && (
                        <Button color="primary" onClick={() => this.store.oublier()}>Fermer</Button>
                    )}
                </ModalFooter>
            </Modal>
        );
    }
}));

export default PaiementCarteModal;
